
import { fetchUtils, Admin, Resource } from 'react-admin'
import { ImpiantiList, ImpiantiCreate, ImpiantiEdit } from './Impianti'
import simpleRestProvider from 'ra-data-simple-rest'
import authProvider from './authentication/authProvider';
import { PersoneCreate, PersoneEdit, PersoneList } from './Persone';
import { ImpiantiShow } from './ImpiantiShow';
import { ManutenzioniCreate, ManutenzioniEdit, ManutenzioniList } from './Manutenzioni';
import { ProdottiCreate, ProdottiEdit, ProdottiList } from './Prodotti';
import { i18nProvider } from './i18nProvider';
import HandymanIcon from  '@mui/icons-material/Handyman';
import ClassIcon from  '@mui/icons-material/Class';
import FactoryIcon from  '@mui/icons-material/Factory';
import PersonIcon from  '@mui/icons-material/Person';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { TabellaManutenzioniCreate, TabellaManutenzioniList } from './TabellaManutenzioni';
import SignIn from './authentication/SignIn';



const httpClient = (url, options = {}) => {
  if (!options.headers) {
      options.headers = new Headers({ Accept: 'application/json' });
  }

  options.headers.set('Access-Control-Allow-Origin', '*')
  const { token } = JSON.parse(localStorage.getItem('auth'));
  options.user = {
    authenticated: true,
    token: `${token}`
  };
  return fetchUtils.fetchJson(url, options);
}

const apiUrl = 'https://muttinservice.it'
export const dataProvider  = simpleRestProvider(apiUrl, httpClient)

function App() {
  return (
    <Admin
      i18nProvider={i18nProvider}
      disableTelemetry
      dataProvider={dataProvider} 
      title="MuttinService"
      authProvider={authProvider}
      loginPage={SignIn}
      requireAuth
    >
      <Resource name="persone" 
        list={PersoneList}
        create={PersoneCreate}
        edit= {PersoneEdit}
        options={{ label: 'Rubrica' }}
        icon = {PersonIcon}
        
      />
      <Resource name="impianti" 
        list={ImpiantiList} 
        create={ImpiantiCreate}
        edit={ImpiantiEdit}
        show={ImpiantiShow}
        options={{ label: 'Impianti' }}
        icon={FactoryIcon}
        
      />
       <Resource name="prodotti" 
        list={ProdottiList}
        create={ProdottiCreate}
        edit= {ProdottiEdit}
        options={{ label: 'Prodotti' }}
        icon = {ClassIcon}
      />
      <Resource name="manutenzioni" 
        list={ManutenzioniList}
        create={ManutenzioniCreate}
        edit= {ManutenzioniEdit}
        icon = {HandymanIcon}
        options={{ label: 'Manutenzioni' }}
      />
     
      <Resource name="tabella_manutenzioni"
        list={TabellaManutenzioniList}
        create={TabellaManutenzioniCreate}
        icon = {FormatListBulletedIcon}
        options={{ label: 'Tabella Manutenzioni' }}
      />
      
    </Admin>
  );
}

export default App;
